/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { Alert, Snackbar } from '@mui/material'
import React, { useContext } from 'react'

import { NotificationContext } from '@/contexts/NotificationContext'

const NotificationAlert: React.FC = () => {
  const { success, error, info, setSuccess, setError, setInfo } =
    useContext(NotificationContext)

  const handleClose = () => {
    setSuccess(undefined)
    setError(undefined)
    setInfo(undefined)
  }

  const errorMessage = error
    ? `The operation could not be completed: ${error}`
    : undefined

  return (
    <Snackbar
      open={!!success || !!error || !!info}
      autoHideDuration={6000} // 6 seconds by default
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={
          success ? 'success' : error ? 'error' : info ? 'info' : undefined
        }
        sx={{ width: '100%' }}
      >
        {success || errorMessage || info}
      </Alert>
    </Snackbar>
  )
}
export default NotificationAlert
